export default screenConfigFindJob = {
  get: function(tutorMatching) {
    if (!(tutorMatching && tutorMatching.UiController)) return [];
    return [
      {
        id: 'type',
        isInputScreen: true,
        inputScreen: {
          progress: '25%',
        },
      },
      {
        id: 'department',
        isInputScreen: true,
        inputScreen: {
          progress: '50%',
        },
        onLoad: function() {
          document.querySelector('.content-container').classList.add('compressed');
        }
      },
      {
        id: 'location',
        isInputScreen: true,
        inputScreen: {
          progress: '75%',
        },
      }, {
        id: 'signup',
        isInputScreen: true,
        inputScreen: {
          progress: '100%',
          hideProgress: true,
        },
        onLoad: function() {
          $('.bg-container').addClass('fixed-height');
          document.querySelector('.content-container').classList.add('compressed');
          var data = tutorMatching.collectedInputs;
          setTimeout(function() {
            var jobType =  $('input[name="employment_type"]');
            if(jobType && jobType.length ) {
              jobType.val(data.type).change();
            }

            var jobField =  $('input[name="job_field"]');
            if(jobField && jobField.length ) {
              jobField.val(data.department).change();
            }

            var jobLocation = $('input[name="job_location"]');
            if(jobLocation && jobLocation.length ) {
              jobLocation.val(data.location).change();
            }
          }, 300);
        }
      },
    ]
  }
}